import { StyleSheet, Platform } from 'react-native';
import { theme } from '../../../theme';

export const friendCardStyles = StyleSheet.create({
  friendCard: {
    backgroundColor: theme.background.card,
    borderRadius: Platform.OS === 'web' ? 12 : 10,
    padding: Platform.OS === 'web' ? 16 : 12,
    marginBottom: Platform.OS === 'web' ? 12 : 8,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderWidth: 2,
    borderColor: 'transparent',
    shadowColor: theme.black,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 3.84,
    elevation: 5,
  },
  selectedFriendCard: {
    borderColor: theme.primary,
    borderWidth: 2,
  },
  friendCardPressed: {
    opacity: 0.7,
  },
  friendInfo: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  friendInfoText: {
    flex: 1,
  },
  friendAvatar: {
    fontSize: Platform.OS === 'web' ? 24 : 20,
    marginRight: Platform.OS === 'web' ? 12 : 10,
  },
  friendAvatarImage: {
    width: Platform.OS === 'web' ? 40 : 36,
    height: Platform.OS === 'web' ? 40 : 36,
    borderRadius: Platform.OS === 'web' ? 20 : 18,
    backgroundColor: theme.gray[200],
    marginRight: Platform.OS === 'web' ? 12 : 10,
  },
  friendAvatarContainer: {
    width: Platform.OS === 'web' ? 40 : 36,
    height: Platform.OS === 'web' ? 40 : 36,
    borderRadius: Platform.OS === 'web' ? 20 : 18,
    backgroundColor: theme.primary + '20',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: Platform.OS === 'web' ? 12 : 10,
  },
  friendAvatarStyle: {
    marginRight: Platform.OS === 'web' ? 12 : 10,
  },
  friendName: {
    fontSize: Platform.OS === 'web' ? 16 : 14,
    fontWeight: '600',
    color: theme.black,
  },
  friendNameSelected: {
    fontSize: Platform.OS === 'web' ? 16 : 14,
    fontWeight: '700',
    color: theme.primary,
  },
  friendEmail: {
    fontSize: Platform.OS === 'web' ? 12 : 11,
    opacity: 0.7,
    marginTop: 2,
  },
  friendCoinsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 2,
    gap: 4,
  },
  friendCoinIcon: {
    width: 14,
    height: 14,
  },
  friendCoinsText: {
    fontSize: Platform.OS === 'web' ? 12 : 11,
    fontWeight: '600',
    color: theme.gray[500],
  },
  friendSelected: {
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: theme.primary,
    alignItems: 'center',
    justifyContent: 'center',
  },
  friendSelectedText: {
    fontSize: 14,
    fontWeight: 'bold',
    color: 'white',
  },
});

